import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getStatusList } from './api_project';

const initialState = {};

export const fetchStatusListData = createAsyncThunk(
  'ui/fetchStatusListData',
  async (obj, thunkAPI) => {
    const { getState } = thunkAPI;
    const response = await getStatusList(obj);
    return response.data;
  }
);

const statusListSlice = createSlice({
  name: 'projectStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatusListData.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          statusDataLoaded: false,
          statusFetchFailed: false,
          statusData: initialState,
        };
      })
      .addCase(fetchStatusListData.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'idle',
          statusData: action.payload,
          statusFetchFailed: false,
          statusDataLoaded: true,
        };
      })
      .addCase(fetchStatusListData.rejected, (state) => {
        return {
          ...state,
          statusFetchFailed: true,
          status: 'idle',
          statusDataLoaded: true,
        };
      });
  },
});

export const getProjectStatuses = (state) => state.projectStatus?.statusData;

export default statusListSlice.reducer;
